import { render } from "./OutboxEmailListing.vue?vue&type=template&id=2f6644b1&scoped=true"
import script from "./OutboxEmailListing.vue?vue&type=script&lang=js"
export * from "./OutboxEmailListing.vue?vue&type=script&lang=js"

import "./OutboxEmailListing.vue?vue&type=style&index=0&id=2f6644b1&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6644b1"]])

export default __exports__